import ReactDOM from 'react-dom/client';
import { TenantContext } from '../../../context/tenant-context';
import { LocationList } from './location-list';
import { v2Component } from '../../../index';

export function initLocationList() {
  document.getElementsByName('location-list').forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);

      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <LocationList {...dataset} />
            </TenantContext.Provider>,
          ),
        );
      };

      bootstrap();
    }
  });
}
